export class Dropdown {
  constructor(selector = '.cookies .dropdown') {
    this.selector = selector;
  }

  init() {
    const dropdowns = document.querySelectorAll(this.selector);

    dropdowns.forEach((dropdown) => {
      const header = dropdown.querySelector('.dropdown__header');
      const content = dropdown.querySelector('.dropdown__content');

      if (!header || !content) return;

      header.addEventListener('click', () => {
        this.toggle(dropdown, content);
      });
    });
  }

  toggle(dropdown, content) {
    const isActive = dropdown.classList.contains('active');

    if (isActive) {
      content.style.maxHeight = '0px';
      dropdown.classList.remove('active');
    } else {
      content.style.maxHeight = `${content.scrollHeight}px`;
      dropdown.classList.add('active');
    }
  }
}
